<template>
    <div>
        <Navbar/>
    </div>
</template>

<script lang="js">
import Navbar from "@/layout/NavBar";

export default {
    name: 'CiePaymentLayout',

    components:{
        Navbar,
    },
    created () {
        console.log("creando header");
    }
};
</script>